import React from 'react';
import Layout from '../components/Layout';
import GlobalAuthorizationLayout from '../components/GlobalAuthorizationLayout';
import CreateCertificate from '../apps/CreateCertificate';
import CheckStaffUserLayout from '../layout/CheckStaffUserLayout';
import CheckViewer from '../layout/CheckViewer';

const CreateCertificatePage: React.FC = () => {
    return (
        <GlobalAuthorizationLayout>
            <CheckStaffUserLayout>
                <CheckViewer>
                    <Layout>
                        <div>
                            <CreateCertificate/>
                        </div>
                    </Layout>
                </CheckViewer>
            </CheckStaffUserLayout>
        </GlobalAuthorizationLayout>
    );
};

export default CreateCertificatePage;
